import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {List} from "immutable";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {CertificateBodiesFetchService} from "./certificate-bodies-fetch.service";

@Injectable()
export class CertificationBodiesResolver implements Resolve<Observable<string[]>> {

	constructor(private fetchService: CertificateBodiesFetchService) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string[]> {
		return this.fetchService.fetchCertificateBodies();
	}
}
